import { observer } from "mobx-react-lite";
import { type FileState } from "@domain/states/order.state";
import { Counter } from "../components/counter";
import { EyeIcon, TrashIcon } from "@boundary/components/icons";
import styles from "./fileListItem.module.scss";

interface FileListItemProps {
  item: FileState;
  selected?: boolean;
  onSelect?: () => void;
  onDelete?: () => void;
  onInspect?: () => void;
}

function FileListItemContent({
  item,
  selected,
  onSelect,
  onInspect,
}: Pick<FileListItemProps, "item" | "selected" | "onSelect" | "onInspect">) {
  return (
    <div
      className={`${styles.content}${selected ? ` ${styles.contentSelected}` : ""}`}
      onClick={onSelect}
    >
      <button
        className={styles.inspectButton}
        disabled={!item.previewUrl}
        onClick={() => {
          console.log(`[Button Click] FileListItem: "Просмотр файла" (file_name: ${item.name})`);
          onInspect?.();
        }}
      >
        <EyeIcon size={24} className={styles.inspectIcon} />
      </button>
      <p className={styles.fileName}>{item.name}</p>
      <Counter item={item} />
    </div>
  );
}

function FileListItemDeleteButton({ onDelete }: Pick<FileListItemProps, "onDelete">) {
  return (
    <button 
      className={styles.deleteButton}
      onClick={() => {
        console.log(`[Button Click] FileListItem: "Удалить файл"`);
        onDelete?.();
      }}
    >
      <TrashIcon className={styles.deleteIcon} />
    </button>
  );
}

export const FileListItem = observer(function FileListItem({
  item,
  selected,
  onSelect,
  onDelete,
  onInspect,
}: FileListItemProps) {
  return (
    <li className={styles.item}>
      <FileListItemContent
        item={item}
        selected={selected}
        onSelect={onSelect}
        onInspect={onInspect}
      />
      <FileListItemDeleteButton onDelete={onDelete} />
    </li>
  );
});
